import type { CharityDonationRequest } from '../api/charityServices/charity-donation-request.service';

export const COMPLETED_DONATION_STATUS_UUID = '3d8b53f5-11e2-4f8b-9d3b-bb86dcd1e646';

export type CharityDonationListStatus =
  | 'Pending'
  | 'Confirmed Received'
  | 'Pending Receival Confirmation';

export type CharityDonationDetailStatus =
  | 'Pending'
  | 'Waiting for Payment'
  | 'Paid - Received';

/** Donation has been paid out to the charity (L2G → charity transfer completed). */
export function isPaidOutToCharity(donation: CharityDonationRequest): boolean {
  if (donation.payment_status === 'completed') {
    return true;
  }

  const statusUuid =
    donation.donation_request_status?.uuid || donation.donation_request_status_uuid;
  if (statusUuid === COMPLETED_DONATION_STATUS_UUID) {
    return true;
  }

  const statusName = (
    donation.donation_request_status?.name ||
    donation.status ||
    ''
  ).toLowerCase();

  return statusName === 'completed' || statusName === 'processed';
}

export function getCharityDonationListStatus(
  donation: CharityDonationRequest
): CharityDonationListStatus {
  if (!isPaidOutToCharity(donation)) {
    return 'Pending';
  }

  return donation.charity_received_at
    ? 'Confirmed Received'
    : 'Pending Receival Confirmation';
}

export function getCharityDonationDetailStatus(
  donation: CharityDonationRequest
): CharityDonationDetailStatus {
  if (donation.charity_received_at) {
    return 'Paid - Received';
  }

  if (isPaidOutToCharity(donation)) {
    return 'Waiting for Payment';
  }

  return 'Pending';
}

export function isAwaitingCharityConfirmation(
  donation: CharityDonationRequest
): boolean {
  return isPaidOutToCharity(donation) && !donation.charity_received_at;
}
